export { default as Img200 } from './processed/200/Spitfire.jpg';
export { default as Img400 } from './processed/400/Spitfire.jpg';
export { default as Imgthumb } from './processed/thumb/Spitfire.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Spitfire.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Spitfire.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      247,
      170,
      98
    ],
    "_population": 979,
    "_hsl": [
      0.08053691275167785,
      0.9030303030303031,
      0.6764705882352942
    ]
  },
  "LightVibrant": {
    "_rgb": [
      246,
      194,
      125
    ],
    "_population": 1455,
    "_hsl": [
      0.09504132231404956,
      0.8705035971223025,
      0.7274509803921568
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      12,
      48,
      85
    ],
    "_population": 5,
    "_hsl": [
      0.5844748858447488,
      0.7525773195876289,
      0.19019607843137254
    ]
  },
  "Muted": {
    "_rgb": [
      95,
      127,
      148
    ],
    "_population": 2442,
    "_hsl": [
      0.5660377358490566,
      0.2181069958847737,
      0.47647058823529415
    ]
  },
  "LightMuted": {
    "_rgb": [
      195,
      190,
      183
    ],
    "_population": 2504,
    "_hsl": [
      0.09722222222222239,
      0.09090909090909079,
      0.7411764705882353
    ]
  },
  "DarkMuted": {
    "_rgb": [
      36,
      53,
      69
    ],
    "_population": 859,
    "_hsl": [
      0.5808080808080808,
      0.3142857142857143,
      0.20588235294117646
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Spitfire.js